import React from 'react';
import PropTypes from 'prop-types';
import I18n from '@app/modules/i18n/index';
import TextField from '@component/form/element/textfield';

import classnames from 'classnames';

import AutoSuggest from '@component/transfer/uploader/autosuggest';
import Icon from '@component/icon';
import Analytics from '@app/modules/analytics/index';

import LockedRecipient from '../locked-recipient';

export default class UploaderRecipients extends React.PureComponent {
  state = {
    showDefaultRecipientMobileInfo: false,
  };

  addRecipient = (email, method = 'typed', nextNode = 'recipientNode') => {
    this.props.addRecipient(email, method);
    if (nextNode && this[nextNode] && this[nextNode].wrappedInstance) {
      this[nextNode].wrappedInstance.focus();
    }
  };

  renderRecipientEntry = (recipient, index) => {
    return (
      <li className="uploader__recipient" key={recipient}>
        {recipient}
        <div
          className={classnames('uploader__remove-recipient', {
            'uploader__recipient--selected':
              index === this.state.selectedRecipient,
          })}
          onClick={() => this.onDeleteRecipient(recipient, 'mouse')}
        >
          <Icon type="Remove" />
        </div>
      </li>
    );
  };

  onDeleteRecipient(email, method) {
    Analytics.pushDataLayerEvent({
      category: 'Transfer',
      action: 'Recipient Removed',
      label: method,
    });

    this.props.removeRecipient(email);
  }

  handleLockedRecipientClick = () => {
    this.setState({
      showDefaultRecipientMobileInfo: true,
    });
  };

  handleLockedRecipientInfoClick = () => {
    this.setState({
      showDefaultRecipientMobileInfo: false,
    });
  };

  renderRecipients = (transfer, lockedRecipient) => {
    const recipientsCount = transfer.recipients && transfer.recipients.length;

    if (lockedRecipient) {
      return (
        <LockedRecipient
          recipient={transfer.recipients[0]}
          onClick={this.handleLockedRecipientClick}
          showMobileInfo={this.state.showDefaultRecipientMobileInfo}
          onInfoClick={this.handleLockedRecipientInfoClick}
        />
      );
    }

    // Attempt to render all recipient entries in a nice list
    let recipients = null;
    if (recipientsCount) {
      recipients = (
        <ul className="uploader__recipients" key="recipients">
          {transfer.recipients.map(this.renderRecipientEntry)}
        </ul>
      );
    }

    const autosuggestProps = {
      key: 'recipient',
      transfer: this.props.transfer,
      recipientCount: 2,
      onRecipient: this.addRecipient.bind(this),
      placeholder: I18n.t('transfer.form.to'),
    };

    const autosuggest = <AutoSuggest {...autosuggestProps} />;

    // Return a recipient list (if applicable) and the input textfield
    return [recipients, autosuggest];
  };

  render() {
    const {
      transfer,
      onSenderBlur,
      onSenderChange,
      lockedRecipient,
      senderEmail,
    } = this.props;

    return (
      <div className="wizard__box">
        <h3>{I18n.t('transfer.mobile.email.title')}</h3>
        <div className={`uploader__recipientsContainer`}>
          {this.renderRecipients(transfer, lockedRecipient)}
        </div>
        <TextField
          key="sender"
          hideLabelOnInput={true}
          type="email"
          name="email"
          value={senderEmail}
          label={I18n.t('transfer.form.from')}
          onChange={onSenderChange}
          onBlur={onSenderBlur}
        />
      </div>
    );
  }
}

UploaderRecipients.propTypes = {
  addRecipient: PropTypes.func.isRequired,
  transfer: PropTypes.object.isRequired,
  onSenderBlur: PropTypes.func.isRequired,
  onSenderChange: PropTypes.func.isRequired,
  removeRecipient: PropTypes.func.isRequired,
  senderEmail: PropTypes.string,
  lockedRecipient: PropTypes.bool,
};
